import { addMinutes } from "date-fns";
import { WorkType } from "../domain/enums/WorkTypeEnum";
import { Mapper } from "../domain/mappers/Mapper";
import { WorkDTO, WorkCreationForm } from "../domain/models/dto/WorkDTO";
import phoneMapperFactory from "./PhoneMapper";
import { SimpleMapper } from "./SimpleMapper";
import worksCategoriesMapperFactory from "./WorksCategoriesMapper";
import addressMapperFactory from "./AddressMapper";

class WorkMapperImpl extends SimpleMapper<WorkCreationForm, WorkDTO> {
    protected commonFields: string[] = [
        "title",
        "price",
        "estimatedHours",
        "workersAmount",
        "startFrom",
        "country",
        "city",
        "address",
        "description",
        "expiresIn",
        "telegram",
        "type",
    ];

    protected toDTOFields: string[] = [...this.commonFields];
    protected fromDTOFields: string[] = [
        ...this.commonFields,
        "id",
        "createdAt",
        "updatedAt",
    ];

    toDTO(form: WorkCreationForm): WorkDTO {
        const dto = super.toDTO(form);
        if (form.phones?.length) {
            const phoneMapper = phoneMapperFactory();
            dto.phones = form.phones
                .filter((phone) => phone.id || phone.phone)
                .map((phone) => phoneMapper.toDTO(phone));
        }
        if (form.address) {
            const addressMapper = addressMapperFactory();
            dto.address = addressMapper.toDTO(form.address);
        }
        if (form.categories?.length) {
            const wcMapper = worksCategoriesMapperFactory();
            dto.categories = form.categories.map((wc) => wcMapper.toDTO(wc));
        }
        dto.type = form.showContactsForAll
            ? WorkType.SHOW_CONTACTS_FOR_ALL
            : WorkType.SHOW_CONTACTS_AFTER_SELECT;

        dto.startFrom = new Date(form.startFrom).toISOString();
        if (form.expiresInMinutes) {
            dto.expiresIn = addMinutes(
                new Date(),
                form.expiresInMinutes
            ).toISOString();
        }
        return dto;
    }
}

export default function workMapperFactory(): Mapper<WorkCreationForm, WorkDTO> {
    return new WorkMapperImpl();
}
